var sku_values_l = ''; 
var sku_values_r = ''; 
var var_l_sph = 'null';
var var_r_sph = 'null';
var var_l_cil = 'null'; 
var var_r_cil = 'null'; 
var var_l_eje = 'null'; 
var var_r_eje = 'null'; 
var l_times = 0;
var r_times = 0; 

$('#right-upc input, #left-upc input').val(val_upc);
$('#left-graduacion').click(function() { var_l_sph = $('#8028070740162_option_4').val(); var var_l_sph_validator = var_l_sph+'_validator'; unify_values_l(); fetch_sku_l(); });
$('#left-cilindro').click(function() { var_l_cil = $('#8028070740162_option_7').val(); var var_l_cil_validator = var_l_sph+'_validator'; unify_values_l(); fetch_sku_l(); });
$('#left-eje').click(function() { var_l_eje = $('#8028070740162_option_8').val(); var var_l_eje_validator = var_l_sph+'_validator'; unify_values_l(); fetch_sku_l(); });
$('#right-graduacion').click(function() { var_r_sph = $('#8028070740162_option_5').val(); var var_r_sph_validator = var_r_sph+'_validator'; unify_values_r(); fetch_sku_r(); });
$('#right-cilindro').click(function() { var_r_cil = $('#8028070740162_option_6').val(); var var_r_cil_validator = var_r_sph+'_validator'; unify_values_r(); fetch_sku_r(); });
$('#right-eje').click(function() { var_r_eje = $('#8028070740162_option_9').val(); var var_r_eje_validator = var_r_sph+'_validator'; unify_values_r(); fetch_sku_r(); });
function unify_values_l(){ sku_values_l = var_l_sph + '_' + var_l_cil + '_' + var_l_eje; console.log(sku_values_l); }
function unify_values_r(){ sku_values_r = var_r_sph + '_' + var_r_cil + '_' + var_r_eje; console.log(sku_values_r); }
function check_times(){
  // 2 = Inmediata, 3 = Exportación, 4 = sin stock
  setTimeout(function(){
    if (l_times == 2){$('.lens-add-btn, .alertLens').show(); $('#left-stock').hide();}  
    if (r_times == 2){$('.lens-add-btn, .alertLens').show(); $('#right-stock').hide();}  
    if (l_times == 4){$('#left-stock').show(); $('.lens-add-btn, .alertLens').hide();} 
    if (r_times == 4){$('#right-stock').show(); $('.lens-add-btn, .alertLens').hide();} 
  },300);
}
function fetch_sku_l(){
  switch (sku_values_l) { 
    //Sin stock
    case '-0.75_-1.75_110°' : $('#left-sku input').val(''); l_times = 4; check_times(); break;
    case '-1.00_-2.25_100°' : $('#left-sku input').val(''); l_times = 4; check_times(); break;
    case 'null' : l_times = 4 ; check_times(); break;
    default: $('#left-sku input').val(''); l_times = 2; check_times(); break; 
  }
}
function fetch_sku_r(){
  switch (sku_values_r) { 
    //Sin stock
    case '-0.75_-1.75_110°' : $('#right-sku input').val(''); r_times = 4; check_times(); break;
    case '-1.00_-2.25_100°' : $('#right-sku input').val(''); r_times = 4; check_times(); break;
    case 'null' : r_times = 4 ; check_times(); break;
    default: $('#right-sku input').val(''); r_times = 2; check_times(); break; 
  }
}